/* ==========================================================
   Baby Yearbooks (BY) – Cart Logic (assets/by-cart.js)
   What this file does:
   1) Holds Checkout button disabled until cart attribute writes complete
   2) Prepaid shipping upsell checkbox (adds/removes hidden product)
   3) Caps qty of 20 free pages to total qty of Bundles + Books
   4) Blocks checkout if free pages in cart but no Bundles or Books
   NOTE: UTM persistence and checkout email pre-fill are now handled
   in theme.liquid to keep all attribution logic in one place.
   ========================================================== */

var BUNDLE_PRODUCT_TYPE = 'Bundles';
var BOOK_PRODUCT_TYPE = 'Books';
var PREPAID_SHIPPING_HANDLE = 'prepaid-shipping';
var FREE_PAGES_VARIANT_ID = 53085461315695;

function qs(id) { return document.getElementById(id); }

function fetchCart() {
  return fetch('/cart.js', { credentials: 'same-origin' }).then(function(r) { return r.json(); });
}

function changeLineItem(line, quantity) {
  return fetch('/cart/change.js', {
    method: 'POST',
    credentials: 'same-origin',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ line: line, quantity: quantity })
  });
}

function addVariantToCart(variantId, quantity) {
  quantity = quantity || 1;
  return fetch('/cart/add.js', {
    method: 'POST',
    credentials: 'same-origin',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ items: [{ id: variantId, quantity: quantity }] })
  });
}

// ----------------------------------------------------------
// refreshCartSections
// Asks Dawn to re-render the cart item and footer sections
// without a full page reload. Used after silent cart changes.
// ----------------------------------------------------------
function refreshCartSections() {
  fetch('/cart?sections=main-cart-items,main-cart-footer,cart-icon-bubble', {
    credentials: 'same-origin'
  })
    .then(function(r) { return r.json(); })
    .then(function(data) {
      var parser = new DOMParser();

      // Re-render cart items
      var itemsEl = document.getElementById('main-cart-items');
      if (itemsEl && data['main-cart-items']) {
        var newItems = parser.parseFromString(data['main-cart-items'], 'text/html');
        var newInner = newItems.getElementById('main-cart-items');
        if (newInner) itemsEl.innerHTML = newInner.innerHTML;
      }

      // Re-render cart footer (triggers MutationObserver → reinits prepaid shipping)
      var footerEl = document.getElementById('main-cart-footer');
      if (footerEl && data['main-cart-footer']) {
        var newFooter = parser.parseFromString(data['main-cart-footer'], 'text/html');
        var newFooterInner = newFooter.getElementById('main-cart-footer');
        if (newFooterInner) footerEl.innerHTML = newFooterInner.innerHTML;
      }

      // Update cart icon bubble count in header
      var bubbleEl = document.getElementById('cart-icon-bubble');
      if (bubbleEl && data['cart-icon-bubble']) {
        var newBubble = parser.parseFromString(data['cart-icon-bubble'], 'text/html');
        var newBubbleInner = newBubble.getElementById('cart-icon-bubble');
        if (newBubbleInner) bubbleEl.innerHTML = newBubbleInner.innerHTML;
      }

      // Re-run checks on the freshly rendered DOM
      enforceCheckoutBlock();
      initPrepaidShipping();
    })
    .catch(function(err) {
      console.error('[BY] refreshCartSections failed:', err);
    });
}

// ----------------------------------------------------------
// initPrepaidShipping
// Called on page load AND whenever Dawn re-renders the cart
// footer section (via MutationObserver below).
// ----------------------------------------------------------
function initPrepaidShipping() {
  var prepaidWrapper = qs('by-prepaid-shipping-wrapper');
  var prepaidCb = qs('by-prepaid-shipping');

  if (!prepaidWrapper || !prepaidCb) return;

  // Already bound in this DOM instance — skip
  if (prepaidCb.dataset.byBound === '1') return;
  prepaidCb.dataset.byBound = '1';

  fetchCart().then(function(cart) {
    var hasBundle = cart.items.some(function(it) { return it.product_type === BUNDLE_PRODUCT_TYPE; });
    if (!hasBundle) {
      prepaidWrapper.style.display = 'none';
      return;
    }

    prepaidWrapper.style.display = 'block';

    var prepaidIndex = cart.items.findIndex(function(it) { return it.handle === PREPAID_SHIPPING_HANDLE; });
    prepaidCb.checked = prepaidIndex >= 0;

    prepaidCb.addEventListener('change', function() {
      fetchCart().then(function(cart2) {
        var idx = cart2.items.findIndex(function(it) { return it.handle === PREPAID_SHIPPING_HANDLE; });
        var line = idx >= 0 ? idx + 1 : 0;
        if (prepaidCb.checked && line === 0) {
          fetch('/products/' + PREPAID_SHIPPING_HANDLE + '.js')
            .then(function(r) { return r.json(); })
            .then(function(p) {
              var variantId = p && p.variants && p.variants[0] && p.variants[0].id;
              if (variantId) return addVariantToCart(variantId);
            })
            .then(function() { location.reload(); }); // reload OK here — user-initiated action
        } else if (!prepaidCb.checked && line > 0) {
          changeLineItem(line, 0).then(function() { location.reload(); }); // reload OK here — user-initiated action
        }
      }).catch(function() {});
    });
  }).catch(function() {});
}

// ----------------------------------------------------------
// enforceFreePagesLimit
// Caps qty of free pages variant to total qty of
// Bundles + Books in the cart. Silently reduces if exceeded.
// Keeps minimum of 1 so the item stays in cart while the
// customer may be swapping books.
// Added: 2026-06-18
// ----------------------------------------------------------
var _enforcingLimit = false; // Re-entrancy guard

function enforceFreePagesLimit() {
  if (_enforcingLimit) return;

  fetchCart().then(function(cart) {
    var freePagesItem = cart.items.find(function(it) {
      return it.variant_id === FREE_PAGES_VARIANT_ID;
    });
    if (!freePagesItem) return;

    var eligibleQty = cart.items
      .filter(function(it) {
        return it.product_type === BUNDLE_PRODUCT_TYPE || it.product_type === BOOK_PRODUCT_TYPE;
      })
      .reduce(function(sum, it) { return sum + it.quantity; }, 0);

    var allowedQty = Math.max(eligibleQty, 1);

    if (freePagesItem.quantity > allowedQty) {
      _enforcingLimit = true;

      // Find the quantity input for the free pages line item and set it directly.
      // Dawn's quantity-input web component will detect the change and sync
      // the cart server-side, avoiding a separate fetch + DOM re-render loop.
      var qtyInput = document.querySelector(
        'input.quantity__input[data-quantity-variant-id="' + FREE_PAGES_VARIANT_ID + '"]'
      );

      if (qtyInput) {
        // Dispatch a native input event so Dawn's web component picks it up
        qtyInput.value = allowedQty;
        qtyInput.dispatchEvent(new Event('change', { bubbles: true }));
        setTimeout(function() { _enforcingLimit = false; }, 1000);
      } else {
        // Fallback: direct API call if input not found in DOM
        fetch('/cart/change.js', {
          method: 'POST',
          credentials: 'same-origin',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: FREE_PAGES_VARIANT_ID, quantity: allowedQty })
        }).then(function() {
          _enforcingLimit = false;
        }).catch(function(err) {
          console.error('[BY] enforceFreePagesLimit change failed:', err);
          _enforcingLimit = false;
        });
      }
    }
  }).catch(function() {});
}

// ----------------------------------------------------------
// enforceCheckoutBlock
// Disables the checkout button and shows a message if the
// free pages product is in the cart but no Bundles or Books
// are present. Re-enables automatically if they add one.
// Added: 2026-06-18
// ----------------------------------------------------------
function enforceCheckoutBlock() {
  fetchCart().then(function(cart) {
    var hasFreePagesItem = cart.items.some(function(it) {
      return it.variant_id === FREE_PAGES_VARIANT_ID;
    });
    if (!hasFreePagesItem) return; // Free pages not in cart, nothing to do

    var hasEligibleItem = cart.items.some(function(it) {
      return it.product_type === BUNDLE_PRODUCT_TYPE || it.product_type === BOOK_PRODUCT_TYPE;
    });

    var checkoutButton = document.querySelector('#checkout');
    if (!checkoutButton) return;

    if (!hasEligibleItem) {
      checkoutButton.disabled = true;
      checkoutButton.style.opacity = '0.5';
      checkoutButton.style.cursor = 'not-allowed';

      if (!document.getElementById('free-pages-warning')) {
        var msg = document.createElement('p');
        msg.id = 'free-pages-warning';
        msg.style.cssText = 'color: #9B59B6; font-size: 14px; margin-top: 8px; text-align: center;';
        msg.textContent = 'Please add a book or bundle to use your 20 free pages.';
        checkoutButton.parentNode.insertBefore(msg, checkoutButton.nextSibling);
      }
    } else {
      checkoutButton.disabled = false;
      checkoutButton.style.opacity = '';
      checkoutButton.style.cursor = '';
      var existingMsg = document.getElementById('free-pages-warning');
      if (existingMsg) existingMsg.remove();
    }
  }).catch(function() {});
}

// ----------------------------------------------------------
// Watch for Dawn re-rendering the cart footer (.js-contents)
// and re-initialise prepaid shipping when it does.
// ----------------------------------------------------------
function observeCartFooter() {
  var footer = document.getElementById('main-cart-footer');
  if (!footer) return;

  var observer = new MutationObserver(function() {
    var wrapper = qs('by-prepaid-shipping-wrapper');
    if (wrapper) wrapper.style.display = 'block';

    initPrepaidShipping();
    enforceCheckoutBlock();
  });

  observer.observe(footer, { childList: true, subtree: true });
}

document.addEventListener('DOMContentLoaded', function() {
  'use strict';

  // Exit immediately on non-cart pages
  if (window.location.pathname !== '/cart') return;

  initPrepaidShipping();
  observeCartFooter();
  enforceFreePagesLimit();
  enforceCheckoutBlock();

// Re-run limit + block checks after Dawn re-renders the cart items section.
  // We watch the DOM instead of listening to the quantity input change event
  // because Dawn's quantity-input web component updates the cart via its own
  // fetch — by the time it re-renders the HTML, /cart.js reflects the true
  // updated state, making this more reliable than a timed delay on 'change'.
  var itemsSection = document.getElementById('main-cart-items');
  if (itemsSection) {
    var itemsObserver = new MutationObserver(function() {
      setTimeout(function() {
        enforceFreePagesLimit();
        enforceCheckoutBlock();
      }, 300);
    });
    itemsObserver.observe(itemsSection, { childList: true, subtree: true });
  }
});